import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Features} from '../features';
import {adapterZbiorUszkodzen, ZbiorUszkodzenState} from './zbiorUszkodzen.reducers';
import {Dictionary} from '@ngrx/entity';
import {ZbiorUszkodzen} from './zbiorUszkodzen';
import {SlownikUszkodzen} from '../../model/uszkodzenia/slownik-uszkodzen';

export const selectZbiorUszkodzen = createFeatureSelector<ZbiorUszkodzenState>(Features.ZBIOR_USZKODZEN);
const {
  selectEntities,
  selectAll
} = adapterZbiorUszkodzen.getSelectors();

export const selectEntitiesZbiorUszkodzen = createSelector(
  selectZbiorUszkodzen,
  selectEntities
);

export const selectZbiorUszkodzenById = createSelector(
  selectEntitiesZbiorUszkodzen,
  (entities: Dictionary<ZbiorUszkodzen>, id: string) => entities[id]
);

export const czyIsteniejeUszkodzenieONazwie = (slownikUszkodzen: SlownikUszkodzen) => createSelector(
  selectEntitiesZbiorUszkodzen,
  (entities: Dictionary<ZbiorUszkodzen>) => Object.values(entities).flatMap(e => e?.uszkodzenia.map(u => u.nazwa)).includes(slownikUszkodzen.nazwa)
);


